const byPropKey = (propertyName, value) => () => {
  return {[propertyName]: value}
};

export default byPropKey


// WEBPACK FOOTER //
// ./src/utilitarios/byPropKey.js